import {SalesOfficeData} from '../../declarations/types'

export const getRfqRegionOffices = (
  offices: SalesOfficeData[],
  selectedRegion: SalesOfficeData
): SalesOfficeData[] =>
  offices.filter(
    (office) =>
      office.region === selectedRegion.region && office.companyName === selectedRegion.companyName
  )

export const getRfqSelectedPlant = (
  offices: SalesOfficeData[],
  persistedOffice?: SalesOfficeData
): SalesOfficeData | undefined => {
  if (offices.length === 1) return offices[0]

  return persistedOffice
    ? offices.find(
        (office) =>
          office.plant === persistedOffice.plant &&
          office.salesOrganization === persistedOffice.salesOrganization &&
          office.companyName === persistedOffice.companyName
      )
    : undefined
}
